<script>
import EventLiveBets from './EventLiveBets.vue';
import EventSelectionFlucs from './EventSelectionFlucs.vue';
import HarnessSelectionStats from '../FormGuideSelectionStats/HarnessSelectionStats.vue';
import SparkLine from '../SparkLine/SparkLine.vue';
import BestOdds from '../BestOdds/BestOdds.vue';
import AccordionTransition from './common/AccordionTransition.vue';
import BookmakerOddsButton from '../BookmakerOddsButton/BookmakerOddsButton.vue';
import BookmakerJoinButton from '../BookmakerOddsButton/BookmakerJoinButton.vue';

export default {
  name: 'EventSelectionRowDesktop',
  components: {
    EventLiveBets,
    EventSelectionFlucs,
    HarnessSelectionStats,
    BestOdds,
    SparkLine,
    AccordionTransition,
    BookmakerOddsButton,
    BookmakerJoinButton,
  },
  props: {
    headers: {
      type: Array,
      required: true,
    },
    selectionData: {
      type: Object,
      required: true,
    },
    selectionStats: {
      type: Object,
      required: true,
    },
    selectionFlucs: {
      type: Array,
      required: true,
    },
    selectionLiveBets: {
      type: Array,
      required: true,
    },
    result: {
      type: String,
      required: true,
    },
    competitor: {
      type: Object,
      required: true,
    },
    competitorString: {
      type: String,
      required: true,
    },
    jockeyName: {
      type: String,
      required: true,
    },
    trainerName: {
      type: String,
      required: true,
    },
    odds: {
      type: Object,
      required: true,
    },
    isScratched: {
      type: Boolean,
      required: true,
    },
    isHarness: {
      type: Boolean,
      required: true,
    },
    showBetsFlucs: {
      type: Boolean,
      required: true,
    },
    expandAllActive: {
      type: Boolean,
      required: true,
    },
    addedGearChanges: {
      type: String,
      required: true,
    },
    removedGearChanges: {
      type: String,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    isFormGuidePage: {
      type: Boolean,
      default: true,
    },
    conversionBookmaker: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isDetailsActive: false,
      isShortListed: false,
      isBlackbooked: false,
    };
  },
  computed: {
    hasGearChanges() {
      return this.selectionData.gear_changes ? this.selectionData.gear_changes.length > 0 : false;
    },
    selectionDataFlucs() {
      return this.selectionFlucs.map(item => {
        return Object.values(item).reverse();
      });
    },
    conversionBookmakerOdds() {
      const { conversionBookmaker } = this;
      const bookmakerOdds = conversionBookmaker
        ? this.selectionData.bookmakerWinOdds.find(item => item.bookmakerId == conversionBookmaker.bookmakerName)
        : [];

      try {
        return bookmakerOdds ? bookmakerOdds.price.value : 0;
      } catch (error) {
        console.log(error);
      }
    },
    lastSixFigure() {
      const { stats } = this.selectionData;
      return stats ? stats.last_six_figure : '';
    },
    lastTenFigure() {
      const { stats } = this.selectionData;
      return stats ? stats.last_ten_figure.slice(-6) : '';
    },
    weight() {
      const { competitor } = this;
      return competitor ? `${competitor.weight}kg` : '';
    },
  },
  methods: {
    toggleDetails() {
      if (this.isFormGuidePage) {
        this.isDetailsActive = !this.isDetailsActive;
      }
    },
    toggleBlackBook() {
      this.isBlackBook = !this.isBlackBook;
    },
    toggleShortListed() {
      this.isShortListed = !this.isShortListed;
    },
    getHeaderColumnValue(headerId) {
      const { competitor, selectionStats } = this;
      // CAREER
      if (headerId === 'career') {
        const { total_places, total_runs } = selectionStats;
        return total_places && total_runs ? `${total_runs}: ${total_places.join('-')}` : '0: 0-0-0';
      }
      // AGE
      if (headerId === 'age') {
        return `${competitor.age}`;
      }
      // WIN %
      if (headerId === 'wins') {
        return `${selectionStats.win_percentage}%`;
      }
      // PLACE %
      if (headerId === 'places') {
        return `${selectionStats.place_percentage}%`;
      }
      // AVERAGE $
      if (headerId === 'average') {
        return `$${selectionStats.average_prize_money}`;
      }
      // RATING
      if (headerId === 'rating') {
        return selectionStats.rating ? `${selectionStats.rating}` : '';
      }
    },
  },
};
</script>

<template>
  <div class="event-selection-row-desktop">
    <!-- selection header -->
    <div class="event-selection-row-header">
      <!-- selection header row details  -->
      <div
        :class="{ expanded: isDetailsActive || expandAllActive || showBetsFlucs }"
        class="event-selection-row-header__row"
        @click="toggleDetails"
      >
        <div class="event-selection-row-left">
          <!-- up/down arrow -->
          <span
            v-if="isFormGuidePage"
            :class="[{ up: isDetailsActive || expandAllActive }]"
            class="event-selection-row-chevron"
          >
            <svg width="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path
                d="M12.682 4.018c.3 0 .5.1.7.3.4.4.4 1 0 1.4l-4.5 4.5 4.5 4.5c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-6-6 6-6c.2 0 .4-.1.7-.1"
                fill="#dddbdd"
              />
            </svg>
          </span>
          <div class="event-selection-row__result">
            <div
              v-if="result > 0"
              :class="`pos-${result}`"
              class="event-selection-row__result-text"
            >
              <p>{{ result }}</p>
            </div>
          </div>
          <!-- silk image -->
          <img
            v-if="selectionData.silk_image_url_medium"
            :src="selectionData.silk_image_url_medium"
            class="event-selection-row__silk"
          >

          <!-- main selection info -->
          <div class="event-selection-row-main-info">
            <div class="event-selection-row-main-info__row">
              <div class="event-selection-row-name">{{ competitorString }}</div>
            </div>
            <div class="event-selection-row-main-info__row">
              <template v-if="isHarness">
                <div class="event-selection-row-main-info__column-left">
                  <div class="event-selection-row-name-details">
                    <span class="highlight">D</span>
                    {{ jockeyName }}
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="event-selection-row-main-info__column-left">
                  <div class="event-selection-row-name-details">{{ weight }}</div>
                </div>
                <div class="event-selection-row-main-info__column-right">
                  <div class="event-selection-row-name-details">
                    <span class="highlight">J</span>
                    {{ jockeyName }}
                  </div>
                </div>
              </template>
            </div>
            <div class="event-selection-row-main-info__row">
              <div class="event-selection-row-main-info__column-left">
                <div class="event-selection-row-name-details">
                  <template v-if="isHarness">
                    <span class="highlight">F</span>
                    {{ lastSixFigure }}
                  </template>
                  <template v-else>{{ lastTenFigure }}</template>
                </div>
              </div>
              <div class="event-selection-row-main-info__column-right">
                <div class="event-selection-row-name-details">
                  <span class="highlight">T</span>
                  {{ trainerName }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="!isHarness && isFormGuidePage" class="event-selection-row-icons">
            <!-- blackbook image -->
            <div v-if="isBlackbooked" class="event-selection-row-blackbook"></div>
            <!-- shortlisted image outline/filled -->
            <a href="#" @click.stop @click.prevent="toggleShortListed">
              <div :class="[{ filled: isShortListed }, 'event-selection-row-shortlisted outline']"></div>
            </a>
          </div>
        </div>
        <div class="event-selection-row-right">
          <template v-for="(header, index) in headers">
            <div
              :key="`right-column-${index}`"
              :class="{ 'full-width' : !isFormGuidePage }"
              class="event-selection-row-right__column"
            >{{ getHeaderColumnValue(header.id) }}</div>
          </template>
          <!-- flucs sparkline -->
          <template v-if="isFormGuidePage">
            <div
              :class="{ 'full-width' : !isFormGuidePage }"
              class="event-selection-row-right__column"
            >
              <SparkLine v-if="!isScratched && selectionDataFlucs" :points="selectionDataFlucs" />
            </div>
            <!-- best odds -->
            <div
              :key="`right-column-bestodds`"
              :class="{ 'full-width' : !isFormGuidePage }"
              class="event-selection-row-right__column"
            >
              <BestOdds
                v-if="!isScratched && odds"
                :selection-id="selectionData.id"
                :odds="odds"
                display="movement"
                @click.stop
              />
            </div>
          </template>
          <!-- bookmaker odds and join buttons -->
          <template v-else>
            <div
              :class="{ 'full-width' : !isFormGuidePage }"
              class="event-selection-row-right__column"
            >
              <BookmakerOddsButton
                v-if="conversionBookmaker && !isScratched"
                :bookmaker-id="conversionBookmaker.bookmakerName"
                :bookmaker-link="conversionBookmaker.primaryBookmakerUrl"
                :value="conversionBookmakerOdds"
              />
            </div>
            <div
              :class="{ 'full-width' : !isFormGuidePage }"
              class="event-selection-row-right__column"
            >
              <BookmakerJoinButton
                v-if="conversionBookmaker && !isScratched"
                :bookmaker-id="conversionBookmaker.bookmakerName"
                :bookmaker-link="conversionBookmaker.secondaryBookmakerUrl"
                :header-text="conversionBookmaker.buttonHeader"
                :details-text="conversionBookmaker.buttonDetails"
              />
            </div>
          </template>
        </div>
      </div>
    </div>

    <template v-if="!isFormGuidePage && selectionData.comments">
      <div class="event-selection-row__conversion-comment">
        <img src="https://puntcdn.com/icons/comment.svg" class="event-selection-row__comment-image" >
        <div class="event-selection-row__comment-text">{{ selectionData.comments }}</div>
      </div>
    </template>

    <!-- expandable accordion filter details (live blog bets and flucs) -->
    <AccordionTransition>
      <div v-if="showBetsFlucs" class="event-selection-row-filter-details">
        <div v-show="filters.showBets" class="event-selection-row-filter__show-bets">
          <EventLiveBets :live-bets="selectionLiveBets" :is-mobile="false" />
        </div>
        <div v-show="filters.showFlucs" class="event-selection-row-filter__show-flucs">
          <EventSelectionFlucs :selection-flucs="selectionFlucs" :is-mobile="false" />
        </div>
      </div>
    </AccordionTransition>

    <!-- expandable accordion selection details -->
    <AccordionTransition>
      <div v-show="isDetailsActive || expandAllActive" class="event-selection-row-details">
        <!-- top section -->
        <div v-if="isHarness" class="event-selection-row-details__top">
          <div class="event-selection-row-details__top-left">
            <div class="event-selection-row-details__top-column">
              <div class="event-selection-row-column__header">COLOUR</div>
              <div class="event-selection-row-column__details">{{ competitor.colour }}</div>
            </div>
            <div class="event-selection-row-details__top-column">
              <div class="event-selection-row-column__header">AGE/SEX</div>
              <div
                class="event-selection-row-column__details"
              >{{ competitor.age }}yo {{ competitor.sex }}</div>
            </div>
            <div class="event-selection-row-details__top-column">
              <div class="event-selection-row-column__header">OWNERS</div>
              <div class="event-selection-row-column__details">{{ competitor.owner }}</div>
            </div>
          </div>
        </div>
        <div v-else class="horse-selection-row-details__top">
          <div class="horse-selection-row-details__top-left">
            <div class="horse-selection-row-details__top-column">
              <div class="horse-selection-row-column__header">COLOUR</div>
              <div class="horse-selection-row-column__details">Chestnut</div>
            </div>
            <div class="horse-selection-row-details__top-column">
              <div class="horse-selection-row-column__header">SIRE</div>
              <div class="horse-selection-row-column__details">Lope de vega (IRE)</div>
            </div>
            <div class="horse-selection-row-details__top-column">
              <div class="horse-selection-row-column__header">AGE/SEX</div>
              <div class="horse-selection-row-column__details">5yo Gelding</div>
            </div>
            <div class="horse-selection-row-details__top-column">
              <div class="horse-selection-row-column__header">DAM</div>
              <div class="horse-selection-row-column__details">Inchberry (GBR)</div>
            </div>
            <div class="horse-selection-row-details__top-column">
              <div class="horse-selection-row-column__header">OWNERS</div>
              <div class="horse-selection-row-column__details">K M Wong, D Devito</div>
            </div>
          </div>
          <div class="horse-selection-row-details__top-right">
            <div class="horse-selection-row-details__buttons">
              <a class="horse-add-tip-btn" href="javascript:void(-1)">
                <p>Add Tip</p>
              </a>
              <a class="horse-black-book-btn" href="#" @click.prevent="toggleBlackBook">
                <p>Black Book</p>
              </a>
            </div>
          </div>
        </div>
        <!-- stats grid section -->
        <template v-if="isHarness">
          <div class="event-selection-row-details__middle">
            <HarnessSelectionStats :is-mobile="false" :selection-stats="selectionStats" />
          </div>
        </template>
        <!-- bottom section -->
        <div v-if="isHarness" class="event-selection-row-details__bottom">
          <div class="event-selection-row-details__bottom-column-right">
            <div v-if="hasGearChanges" class="event-selection-row-column__header">GEAR CHANGES</div>
            <div class="event-selection-row-column__details">
              <div class="gear-changes-row">
                <span v-if="addedGearChanges">
                  <b>Added:</b>
                  {{ addedGearChanges }}
                </span>
                <span v-if="removedGearChanges">
                  <b>Removed:</b>
                  {{ removedGearChanges }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="horse-selection-row-details__bottom">
          <div class="horse-selection-row-details__bottom-column-left">
            <div class="horse-selection-row-column__header">RUNNER COMMENT</div>
            <div class="horse-selection-row-column__details"></div>
          </div>
          <div class="horse-selection-row-details__bottom-column-right">
            <div class="horse-selection-row-column__header">GEAR CHANGES</div>
            <div class="horse-selection-row-column__details"></div>
          </div>
        </div>
      </div>
    </AccordionTransition>
  </div>
</template>
